import $ from "jquery";

(function($) {
    let cboxOptions = {
        width: '95%',
        height: '95%',
        maxWidth: '960px',
        maxHeight: '700px',
        top: '15%',
        iframe: true,
        href:'https://test-strip-app.web.app/'
    }

    function analyseWaterColorbox() {
       let $iframe = $('#analyze-water').colorbox(cboxOptions);
       return $iframe;
    }

    function volumeCalculator() {
        let href = 'https://calculateur-marina-easy.web.app/';
        let volumeCalculator = {...cboxOptions, href};
        let $iframe = $('#volume-calculator').colorbox(volumeCalculator);
        return $iframe;
    }

    $(window).on('load', function() {
        analyseWaterColorbox();
        volumeCalculator();
    });
    $('#volume-calculator').on('focus', function() {
        $(this).blur();
    });
    $('#analyze-water').on('focus', function() {
        $(this).blur();
    });

})(jQuery);